export interface SearchContentHit {
  id: string;
  slug: string;
  title: string;
  description: string | null;
  section: string | null;
  categoryId: string | null;
  subcategoryId: string | null;
  rank: number;
}

export interface SearchCategoryHit {
  id: string;
  name: string;
  section: string;
  rank: number;
}

export interface SearchSubcategoryHit {
  id: string;
  name: string;
  body: string | null;
  categoryId: string;
  /** Parent category's name — Library URL pattern uses `?category=<name>`. */
  categoryName: string;
  /** Parent category's section. */
  section: string;
  rank: number;
}

export interface SearchResponse {
  contents: SearchContentHit[];
  categories: SearchCategoryHit[];
  subcategories: SearchSubcategoryHit[];
}

/**
 * Fetch library search results. Public endpoint — works for both anon
 * and authenticated users (credentials: 'include' so the auth context
 * is read by the backend if the user is signed in, gating access).
 */
export async function searchContent(
  q: string,
  limit = 8
): Promise<SearchResponse> {
  const trimmed = q.trim();
  if (trimmed.length === 0) {
    return { contents: [], categories: [], subcategories: [] };
  }
  const params = new URLSearchParams({ q: trimmed, limit: String(limit) });
  const response = await fetch(`/api/v1/search?${params.toString()}`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error(`search: ${response.status}`);
  }
  return (await response.json()) as SearchResponse;
}
